import {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
  useLayoutEffect,
} from "react";
import { Link, useLocation } from "react-router-dom";
import "./minor.css";
import "./MobileNavigation.css";

const T = {
  en: {
    search: "Search the site...",
    by: "by",
    unknownAuthor: "Unknown author",
    moreResults: (n) => `+${n} more results`,
    latestFor: (name) => `Latest for ${name}`,
    latestProjectNews: "Latest project news",
    latestNews: "Latest news",
    typeArticle: "Article",
    typeProject: "Project",
    typeUpdate: "Update",
    typeAnnouncement: "Announcement",
    typeAuthor: "Author",
    typeCategory: "Category",
  },
  pl: {
    search: "Szukaj na stronie...",
    by: "autor",
    unknownAuthor: "Nieznany autor",
    moreResults: (n) => `+${n} więcej wyników`,
    latestFor: (name) => `Najnowsze dla ${name}`,
    latestProjectNews: "Najnowsze aktualności projektu",
    latestNews: "Najnowsze aktualności",
    typeArticle: "Artykuł",
    typeProject: "Projekt",
    typeUpdate: "Aktualizacja",
    typeAnnouncement: "Ogłoszenie",
    typeAuthor: "Autor",
    typeCategory: "Kategoria",
  },
};

const navBarList = [
  // {
  //   id: 0,
  //   title: "Home",
  //   desc: "Start here — latest updates and highlights",
  //   img: "../bg_home.jpg",
  //   args: [
  //     {
  //       id: "h0",
  //       type: "link",
  //       name: "Main Page",
  //       desc: "Welcome screen and featured content",
  //       img: "",
  //       href: "/",
  //     },
  //     {
  //       id: "h1",
  //       type: "link",
  //       name: "Latest News",
  //       desc: "Recent announcements and devlogs",
  //       img: "",
  //       href: "/news",
  //     },
  //     {
  //       id: "h2",
  //       type: "link",
  //       name: "Quick Links",
  //       desc: "Jump straight to key project sections",
  //       img: "",
  //       href: "/quick-links",
  //     },
  //   ],
  // },
  {
    id: 1,
    title: "Projects",
    desc: "Explore my main work: games, tools, and experiments",
    img: "../bg_projects.jpg",
    args: [
      {
        id: "pall",
        type: "link",
        name: "All",
        desc: "Indie game currently in development",
        img: "",
        href: "/projects",
      },
      {
        id: "p0",
        type: "link",
        name: "Liquidators",
        desc: "Indie game currently in development",
        img: "",
        href: "/projects/gerczak",
        projectId: "liquidators",
      },
      {
        id: "p1",
        type: "link",
        name: "Outpost 9",
        desc: "Indie game currently in development",
        img: "",
        href: "/projects/gerczak",
        projectId: "outpost9",
      },
      {
        id: "p2",
        type: "link",
        name: "QuickBlocksUI",
        desc: "Custom React components that can be used to build modern and responsive user interfaces. The package includes a range of UI elements.",
        img: "",
        href: "https://quickblocksui.netlify.app",
        projectId: "quickblocksui",
      },
      {
        id: "p3",
        type: "link",
        name: "Texturio",
        desc: "Managing and optimizing work with multiple textures, especially in the context of computer graphics or game development, involves several key strategies to ensure efficiency and performance. Here are some approaches and best practices.",
        img: "",
        href: "https://toptimizer.netlify.app",
        projectId: "texturio",
      },
      {
        id: "p4",
        type: "link",
        name: "Dam Simulator",
        desc: "Tool simulating how is dam working",
        img: "",
        href: "https://toptimizer.netlify.app",
        projectId: "damsim",
      },
    ],
  },
  {
    id: 2,
    title: "News",
    desc: "Devlogs, updates, and release notes",
    img: "../bg_news.jpg",
    args: [
      {
        id: "n0",
        type: "link",
        name: "Devlogs",
        desc: "Behind the scenes of development",
        img: "",
        href: "/news/devlogs",
      },
      {
        id: "n1",
        type: "link",
        name: "Releases",
        desc: "Announcements and updates",
        img: "",
        href: "/news/releases",
      },
    ],
  },
  {
    id: 3,
    title: "About",
    desc: "Who I am and how to reach me",
    img: "../bg_about.jpg",
    args: [
      {
        id: "a0",
        type: "link",
        name: "About Me",
        desc: "Short bio and contact information",
        img: "",
        href: "/about",
      },
      {
        id: "a1",
        type: "link",
        name: "Profiles",
        desc: "Meet all authors contributing to the project",
        img: "",
        href: "/profiles",
      },
    ],
  },
  {
    id: 4,
    title: "Community",
    desc: "Join the conversation or follow me online",
    img: "../bg_community.jpg",
    args: [
      {
        id: "c0",
        type: "link",
        name: "YouTube",
        desc: "Gaming and devlog channels",
        img: "",
        href: "https://youtube.com/@yourchannel",
      },
      {
        id: "c1",
        type: "link",
        name: "Instagram",
        desc: "Art and development snippets",
        img: "",
        href: "https://instagram.com/yourprofile",
      },
      {
        id: "c2",
        type: "link",
        name: "Discord",
        desc: "Chat and community hub",
        img: "",
        href: "https://discord.gg/yourinvite",
      },
    ],
  },
];

const NavBar = ({
  projects = [],
  news = [],
  updates = [],
  authors = [],
  announcements = [],
  theme = "dark",
  onThemeToggle = () => {},
  lang = "en",
  onLangToggle = () => {},
  perfMode = false,
  onPerfModeToggle = () => {},
}) => {
  const location = useLocation();
  const [summaryVisible, setSummaryVisible] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [mobileMenuVisible, setMobileMenuVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const t = useMemo(() => T[lang] || T.en, [lang]);

  const toTime = useCallback((dateString) => {
    if (!dateString || typeof dateString !== "string") return 0;
    const parts = dateString.split(/[./-]/).map((p) => Number(p));
    if (parts.length < 3) return 0;
    const [day, month, year] = parts;
    if (!day || !month || !year) return 0;
    return new Date(year, month - 1, day).getTime();
  }, []);

  const toSlug = useCallback((title) => {
    if (!title || typeof title !== "string") return "article";
    return title
      .trim()
      .replace(/[\s:]+/g, "-")
      .replace(/[^\w-]+/g, "")
      .toLowerCase();
  }, []);

  const getImageSrc = useCallback((file) => {
    if (!file || typeof file !== "string") return "";
    const normalized = file.replace(/^(\.\.\/)+/, "");
    return `/images/${normalized}`;
  }, []);

  const resolveMediaSrc = useCallback(
    (src) => {
      if (!src || typeof src !== "string") return "";
      if (src.startsWith("http")) return src;
      if (src.startsWith("/")) return src;
      return getImageSrc(src);
    },
    [getImageSrc],
  );

  const truncateText = useCallback((text, maxChars) => {
    if (!text || typeof text !== "string") return "";
    if (!Number.isFinite(maxChars) || maxChars <= 0) return "";
    const cleaned = text.replace(/\s+/g, " ").trim();
    if (cleaned.length <= maxChars) return cleaned;
    return `${cleaned.slice(0, Math.max(0, maxChars - 1))}…`;
  }, []);

  const getArticleHref = useCallback(
    (article) => {
      const id = article?.id ?? "0";
      return `/article/${id}/${toSlug(article?.title)}`;
    },
    [toSlug],
  );

  const getLatestNews = useCallback(
    ({ projectId, onlyProjectNews } = {}) => {
      const newsData = Array.isArray(news) ? news : [];
      const filtered = (Array.isArray(newsData) ? newsData : [])
        .filter(Boolean)
        .filter((n) => {
          if (projectId) {
            const related = Array.isArray(n.relatedProjects)
              ? n.relatedProjects
              : [];
            return n.projectId === projectId || related.includes(projectId);
          }
          if (onlyProjectNews) return !!n.projectId;
          return true;
        })
        .sort((a, b) => toTime(b.date) - toTime(a.date));

      return filtered.slice(0, 2);
    },
    [news, toTime],
  );

  // Search functionality state
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchVisible, setSearchVisible] = useState(false);
  const [desktopSearchModalOpen, setDesktopSearchModalOpen] = useState(false);
  const [searchFilter, setSearchFilter] = useState("all");

  // Hierarchical navigation state
  const [currentNavLevel, setCurrentNavLevel] = useState("main"); // 'main' or category id
  const [navBreadcrumbs, setNavBreadcrumbs] = useState(["Home"]);

  // Comprehensive search functionality
  const handleSearch = useCallback(
    (query) => {
      setSearchQuery(query);
      if (query.trim().length > 2) {
        const results = [];
        const searchTerm = query.toLowerCase();

        // Search through news/articles
        const newsData = news && news.length > 0 ? news : [];
        newsData.forEach((article) => {
          if (!article) return; // Skip if article is null/undefined

          const titleMatch =
            article.title && typeof article.title === "string"
              ? article.title.toLowerCase().includes(searchTerm)
              : false;
          const contentMatch =
            article.content && typeof article.content === "string"
              ? article.content.toLowerCase().includes(searchTerm)
              : false;
          const categoryMatch =
            article.category && typeof article.category === "string"
              ? article.category.toLowerCase().includes(searchTerm)
              : false;

          if (titleMatch || contentMatch || categoryMatch) {
            // Find author by authorId
            const author =
              authors && Array.isArray(authors)
                ? authors.find((a) => a.id === article.authorId)
                : null;

            results.push({
              type: "article",
              id: article.id,
              title: article.title,
              content:
                article.content && typeof article.content === "string"
                  ? article.content.substring(0, 120) + "..."
                  : "",
              category: article.category || t.typeArticle,
              date: article.date || article.publishDate,
              author: author
                ? author.nickname
                : article.authorId === null || article.authorId === undefined
                  ? "admin"
                  : t.unknownAuthor,
              articleType: article.articleType,
              href: `/article/${article.id}/${
                article.title && typeof article.title === "string"
                  ? article.title
                      .slice(0, -1)
                      .replace(/[\s:]+/g, "-")
                      .toLowerCase()
                  : "article"
              }`,
            });
          }
        });

        // Search through projects - add safety check
        if (projects && Array.isArray(projects)) {
          projects.forEach((project) => {
            if (!project) return; // Skip if project is null/undefined

            const titleMatch =
              project.title && typeof project.title === "string"
                ? project.title.toLowerCase().includes(searchTerm)
                : false;
            const descMatch =
              project.description && typeof project.description === "string"
                ? project.description.toLowerCase().includes(searchTerm)
                : false;
            const categoryMatch =
              project.category && typeof project.category === "string"
                ? project.category.toLowerCase().includes(searchTerm)
                : false;
            const statusMatch =
              project.status && typeof project.status === "string"
                ? project.status.toLowerCase().includes(searchTerm)
                : false;

            if (titleMatch || descMatch || categoryMatch || statusMatch) {
              results.push({
                type: "project",
                id: project.id,
                title: project.title,
                content:
                  project.description && typeof project.description === "string"
                    ? project.description.substring(0, 120) + "..."
                    : "",
                category: project.category || t.typeProject,
                status: project.status,
                timeline: project.timeline,
                href: `/projects/${project.id}`,
              });
            }
          });
        }

        // Search through updates - add safety check
        if (updates && Array.isArray(updates)) {
          updates.forEach((update) => {
            if (!update) return; // Skip if update is null/undefined

            const titleMatch =
              update.title && typeof update.title === "string"
                ? update.title.toLowerCase().includes(searchTerm)
                : false;
            const contentMatch =
              update.content && typeof update.content === "string"
                ? update.content.toLowerCase().includes(searchTerm)
                : false;

            if (titleMatch || contentMatch) {
              results.push({
                type: "update",
                id: update.id,
                title: update.title,
                content:
                  update.content && typeof update.content === "string"
                    ? update.content.substring(0, 120) + "..."
                    : "",
                category: t.typeUpdate,
                date: update.date,
                href: `/updates#${update.id}`,
              });
            }
          });
        }

        // Search through authors - add safety check
        if (authors && Array.isArray(authors)) {
          authors.forEach((author) => {
            if (!author) return; // Skip if author is null/undefined

            const nicknameMatch =
              author.nickname && typeof author.nickname === "string"
                ? author.nickname.toLowerCase().includes(searchTerm)
                : false;
            const bioMatch =
              author.bio && typeof author.bio === "string"
                ? author.bio.toLowerCase().includes(searchTerm)
                : false;
            const nameMatch =
              author.name && typeof author.name === "string"
                ? author.name.toLowerCase().includes(searchTerm)
                : false;

            if (nicknameMatch || bioMatch || nameMatch) {
              results.push({
                type: "author",
                id: author.id,
                title: author.nickname || author.name,
                content: author.bio?.substring(0, 120) + "...",
                category: t.typeAuthor,
                href: `/authors/${author.id}`,
              });
            }
          });
        }

        // Search through announcements - add safety check
        if (announcements && Array.isArray(announcements)) {
          announcements.forEach((announcement) => {
            if (!announcement) return; // Skip if announcement is null/undefined

            const titleMatch =
              announcement.title && typeof announcement.title === "string"
                ? announcement.title.toLowerCase().includes(searchTerm)
                : false;
            const contentMatch =
              announcement.content && typeof announcement.content === "string"
                ? announcement.content.toLowerCase().includes(searchTerm)
                : false;

            if (titleMatch || contentMatch) {
              results.push({
                type: "announcement",
                id: announcement.id,
                title: announcement.title,
                content:
                  announcement.content &&
                  typeof announcement.content === "string"
                    ? announcement.content.substring(0, 120) + "..."
                    : "",
                category: t.typeAnnouncement,
                date: announcement.date,
                href: `/news#announcement-${announcement.id}`,
              });
            }
          });
        }

        // Sort results by relevance (title matches first, then content matches)
        results.sort((a, b) => {
          const aTitle =
            a.title && typeof a.title === "string"
              ? a.title.toLowerCase().includes(searchTerm)
                ? 1
                : 0
              : 0;
          const bTitle =
            b.title && typeof b.title === "string"
              ? b.title.toLowerCase().includes(searchTerm)
                ? 1
                : 0
              : 0;
          return bTitle - aTitle;
        });

        // Filter results based on selected filter
        const filteredResults =
          searchFilter === "all"
            ? results
            : results.filter((result) => result.type === searchFilter);

        setSearchResults(filteredResults);
        setSearchVisible(true);
      } else {
        setSearchResults([]);
        setSearchVisible(false);
      }
    },
    [news, projects, updates, authors, announcements, searchFilter, t],
  );

  // Re-filter results when filter changes
  useEffect(() => {
    if (searchQuery.trim().length > 2) {
      handleSearch(searchQuery);
    }
  }, [searchFilter, searchQuery, handleSearch]);

  const clearSearch = () => {
    setSearchQuery("");
    setSearchResults([]);
    setSearchVisible(false);
    setDesktopSearchModalOpen(false);
    setSearchFilter("all");
  };

  // Funkcja tylko do czyszczenia inputa (bez zamykania modala)
  const clearSearchInput = () => {
    setSearchQuery("");
    setSearchResults([]);
    setSearchVisible(false);
  };

  // Desktop search modal functions
  const openDesktopSearchModal = () => {
    setDesktopSearchModalOpen(true);
    setSearchVisible(false);
    setSearchQuery("");
    setSearchResults([]);
    // Blokuj scroll strony
    document.body.style.overflow = "hidden";
  };

  const closeDesktopSearchModal = () => {
    setDesktopSearchModalOpen(false);
    clearSearch();
    // Przywróć scroll strony
    document.body.style.overflow = "unset";
  };

  // Navigation helper functions
  const navigateToCategory = (category) => {
    setCurrentNavLevel(category.id);
    setNavBreadcrumbs(["Home", category.title]);
  };

  const navigateBack = () => {
    if (currentNavLevel !== "main") {
      setCurrentNavLevel("main");
      setNavBreadcrumbs(["Home"]);
    }
  };

  const resetNavigation = () => {
    setCurrentNavLevel("main");
    setNavBreadcrumbs(["Home"]);
    setMobileMenuVisible(false);
    clearSearch();
  };

  // Handle body scroll lock for mobile menu
  useEffect(() => {
    if (mobileMenuVisible) {
      document.body.classList.add("mobile-menu-open");
    } else {
      document.body.classList.remove("mobile-menu-open");
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove("mobile-menu-open");
    };
  }, [mobileMenuVisible]);

  // Funkcja do określenia nazwy aktualnej strony
  // eslint-disable-next-line no-unused-vars
  const getCurrentPageName = () => {
    const path = location.pathname;
    if (path === "/") return "";
    if (path === "/projects") return "Projects";
    if (path === "/news") return "News";
    if (path === "/profiles") return "About";
    if (path.startsWith("/profiles/")) return "About";
    if (path.startsWith("/article/")) return "News";
    if (path === "/roadmap") return "Roadmap";
    return "";
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navbarStyle = {
    top: "0px",
    width: "100%",
    transition: "none",
  };
  const [isHovered, setIsHovered] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [activeSubMenu, setActiveSubMenu] = useState(0);
  const [activeDesc, setActiveDesc] = useState(69);
  const navListRef = useRef(null);
  const lastIndicatorAnchorRef = useRef(null);
  const subNavListRef = useRef(null);
  const lastSubIndicatorAnchorRef = useRef(null);
  const [navIndicatorStyle, setNavIndicatorStyle] = useState({
    "--nav-indicator-x": "0px",
    "--nav-indicator-y": "0px",
    "--nav-indicator-w": "0px",
    "--nav-indicator-h": "0px",
    "--nav-indicator-o": "0",
  });
  const [subIndicatorStyle, setSubIndicatorStyle] = useState({
    "--sub-indicator-y": "0px",
    "--sub-indicator-h": "0px",
    "--sub-indicator-o": "0",
  });

  const setIndicatorToAnchor = useCallback((anchor) => {
    if (!navListRef.current || !anchor) return;
    lastIndicatorAnchorRef.current = anchor;
    const listRect = navListRef.current.getBoundingClientRect();
    const rect = anchor.getBoundingClientRect();
    const x = rect.left - listRect.left;
    const y = rect.top - listRect.top;
    setNavIndicatorStyle({
      "--nav-indicator-x": `${x}px`,
      "--nav-indicator-y": `${y}px`,
      "--nav-indicator-w": `${rect.width}px`,
      "--nav-indicator-h": `${rect.height}px`,
      "--nav-indicator-o": "1",
    });
  }, []);

  const syncIndicatorToActive = useCallback(() => {
    if (!navListRef.current) return;
    const activeAnchor = navListRef.current.querySelector(
      "li.nav-item.is-active > a",
    );
    if (activeAnchor) setIndicatorToAnchor(activeAnchor);
  }, [setIndicatorToAnchor]);

  const handleNavListMouseLeave = useCallback(() => {
    if (isHovered) return;
    syncIndicatorToActive();
  }, [isHovered, syncIndicatorToActive]);

  const handleNavItemHover = useCallback(
    (e) => {
      const anchor = e?.currentTarget?.querySelector("a");
      if (anchor) setIndicatorToAnchor(anchor);
    },
    [setIndicatorToAnchor],
  );

  const setSubIndicatorToAnchor = useCallback((anchor) => {
    if (!subNavListRef.current || !anchor) return;
    lastSubIndicatorAnchorRef.current = anchor;

    const listEl = subNavListRef.current;
    const listRect = listEl.getBoundingClientRect();
    const rect = anchor.getBoundingClientRect();
    const y = rect.top - listRect.top + listEl.scrollTop;

    setSubIndicatorStyle({
      "--sub-indicator-y": `${Math.max(0, y)}px`,
      "--sub-indicator-h": `${rect.height}px`,
      "--sub-indicator-o": "1",
    });
  }, []);

  const syncSubIndicatorToActive = useCallback(() => {
    if (!subNavListRef.current) return;
    const activeLink = subNavListRef.current.querySelector(
      ".navSubLink.is-active",
    );
    if (activeLink) setSubIndicatorToAnchor(activeLink);
  }, [setSubIndicatorToAnchor]);

  const handleSubItemHover = useCallback(
    (e) => {
      const anchor = e?.currentTarget;
      if (anchor) setSubIndicatorToAnchor(anchor);
    },
    [setSubIndicatorToAnchor],
  );

  const handleSubListScroll = useCallback(() => {
    const anchor =
      lastSubIndicatorAnchorRef.current ||
      subNavListRef.current?.querySelector(".navSubLink.is-active");
    if (anchor) setSubIndicatorToAnchor(anchor);
  }, [setSubIndicatorToAnchor]);

  useLayoutEffect(() => {
    syncIndicatorToActive();
  }, [syncIndicatorToActive, location.pathname]);

  useLayoutEffect(() => {
    if (!isHovered) return;
    syncSubIndicatorToActive();
  }, [syncSubIndicatorToActive, isHovered, activeSubMenu, activeDesc]);

  useEffect(() => {
    if (!isHovered) return;
    const args = navBarList?.[activeSubMenu]?.args;
    if (!Array.isArray(args) || args.length === 0) return;
    if (activeDesc === 69 || activeDesc >= args.length) setActiveDesc(0);
  }, [isHovered, activeSubMenu, activeDesc]);

  useEffect(() => {
    const handleResize = () => {
      const anchor =
        lastIndicatorAnchorRef.current ||
        navListRef.current?.querySelector("li.nav-item.is-active > a");
      if (anchor) setIndicatorToAnchor(anchor);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [setIndicatorToAnchor]);
  const NavItem = ({ title, id, index }) => {
    const handleMouseEnter = (e) => {
      handleNavItemHover(e);
      setIsHovered(true);
      setActiveSubMenu(index);
      setHoveredItem(index);
    };

    const handleMouseLeave = () => {
      // Dodaj małe opóźnienie przed ukryciem menu
      setTimeout(() => {
        if (!document.querySelector(".navBarItemWrappMain:hover")) {
          setIsHovered(false);
          setHoveredItem(null);
        }
      }, 150);
    };

    // Określ ścieżkę na podstawie id
    const getPath = () => {
      switch (id) {
        case 1:
          return "/projects";
        case 2:
          return "/news";
        case 3:
          return "/profiles";
        case 4:
          return "#"; // Community nie ma dedykowanej strony
        default:
          return "/";
      }
    };

    // Jeśli to Home, zwróć jako link
    if (id === 0) {
      const isActive = location.pathname === "/";
      return (
        <li className={`nav-item ${isActive ? "is-active" : ""}`}>
          <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
            <span className="nav-link-text">{title}</span>
          </Link>
        </li>
      );
    }

    const hasSubmenu = !!navBarList?.[index]?.args?.length;
    const isOpen = isHovered && activeSubMenu === index;
    const isActive = location.pathname.startsWith(getPath());

    return (
      <li
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className={`nav-item ${hasSubmenu ? "has-submenu" : ""} ${isOpen ? "submenu-open" : ""} ${isActive ? "is-active" : ""}`}
      >
        <Link
          to={getPath()}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <span className="nav-link-text">{title}</span>
          {hasSubmenu ? (
            <span className="nav-item-chevron" aria-hidden="true">
              ▾
            </span>
          ) : null}
        </Link>
      </li>
    );
  };
  const NavItemDesc = ({ title, id, href, isActive }) => {
    const handleMouseEnter = (e) => {
      setActiveDesc(id);
      handleSubItemHover(e);
    };

    return (
      <Link
        onMouseEnter={handleMouseEnter}
        to={href}
        className={`navSubLink ${isActive ? "is-active" : ""}`}
      >
        <span className="navSubLink-name">{title}</span>
        <span className="navSubLink-arrow">›</span>
      </Link>
    );
  };

  return (
    <div
      className={`navbar-wrapper ${location.pathname === "/" ? "homepage" : ""}`}
    >
      <div className={`summaryContent ${summaryVisible ? "visible" : ""}`}>
        <div className="summaryHeader">
          {/* Pierwszy navbar logo - dla zwykłych ścieżek */}
          {!(
            location.pathname.startsWith("/news") ||
            location.pathname.startsWith("/updates")
          ) && (
            <div className="navBarLogoWrapper">
              <div
                className="navBarLogo"
                onClick={() => setSummaryVisible(!summaryVisible)}
                style={{ cursor: "pointer" }}
              >
                <p>
                  <img
                    src="/logo.png"
                    alt="logo"
                    style={{ width: "62px", height: "62px" }}
                  />
                </p>
                <div className="logo-text-container">
                  <p className="text-animate-brand">tehaque.dev</p>
                  <p className="text-animate-rotate">
                    {summaryVisible ? "▲" : "▼"}
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* Drugi navbar logo - dla news/updates */}
          {(location.pathname.startsWith("/news") ||
            location.pathname.startsWith("/updates")) && (
            <div
              className="navBarLogo extended-logo"
              onClick={() => setSummaryVisible(!summaryVisible)}
              style={{ cursor: "pointer" }}
            >
              <p>
                <img
                  src="/logo.png"
                  alt="logo"
                  style={{ width: "62px", height: "62px" }}
                />
              </p>
              <div className="logo-text-container">
                {location.pathname.startsWith("/updates") ? (
                  <>
                    <p className="text-animate-brand">tehaque.dev Updates</p>
                    <span className="beta-badge">BETA</span>
                  </>
                ) : (
                  <p className="text-animate-brand">tehaque.dev News</p>
                )}
                <p className="text-animate-rotate">
                  {summaryVisible ? "▲" : "▼"}
                </p>
              </div>
            </div>
          )}

          <button
            className="closeSummary"
            onClick={() => setSummaryVisible(false)}
          >
            ×
          </button>
        </div>
        <div className="summaryBody">
          <div className="megaMenuLeft">
            {navBarList.map((category) => (
              <div key={category.id} className="menuColumn">
                <div className="columnTitleWrap">
                  <h3 className="columnTitle">{category.title}</h3>
                </div>
                <div className="columnLinks">
                  {category.args.map((item) => (
                    <Link
                      key={item.id}
                      to={item.href}
                      className="columnLink text-animate-hover-slide"
                      onClick={() => setSummaryVisible(false)}
                      onMouseEnter={() => setHoveredItem(item)}
                      onMouseLeave={() => setHoveredItem(null)}
                    >
                      {item.name}
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div className={hoveredItem ? "segaMenuRight" : "megaMenuRight"}>
            {hoveredItem ? (
              <div className="hoveredItemDisplay">
                <div className="promoCard hoveredPromoCard">
                  <div
                    className="promoImage"
                    style={{ backgroundImage: `url(${hoveredItem.img})` }}
                  ></div>
                  <div className="promoContent">
                    <h3 className="text-animate-zoom-in">{hoveredItem.name}</h3>
                    <p className="text-animate-fade-up">{hoveredItem.desc}</p>
                  </div>
                </div>
              </div>
            ) : (
              <>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a href="#" className="linkPromoCard">
                  <div className="promoCard">
                    <div
                      className="promoImage"
                      style={{
                        backgroundImage:
                          "url(https://images.contentstack.io/v3/assets/blt187521ff0727be24/blt8b6a5b8b0b6b8b8b/60b8b8b8b8b8b8b8/valorant-key-art.jpg)",
                      }}
                    ></div>
                    <div className="promoContent">
                      <h3>{navBarList[0].args[2].name}</h3>
                      <p>{navBarList[0].args[2].desc}</p>
                    </div>
                  </div>
                </a>
                <div className="promoCard">
                  <div
                    className="promoImage"
                    style={{
                      backgroundImage:
                        "url(https://images.contentstack.io/v3/assets/blt187521ff0727be24/blt8b6a5b8b0b6b8b8b/60b8b8b8b8b8b8b8/tft-key-art.jpg)",
                    }}
                  ></div>
                  <div className="promoContent">
                    <h3>{navBarList[0].args[3].name}</h3>
                    <p>
                      {navBarList[0].args[3].desc.slice(0, 215).concat("...")}
                    </p>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <nav
        className={`navBarMain ${location.pathname.startsWith("/updates") ? "updates-navbar" : ""}`}
        style={navbarStyle}
      >
        <ul
          className="navBarList"
          ref={navListRef}
          style={navIndicatorStyle}
          onMouseLeave={handleNavListMouseLeave}
        >
          {/* Pierwszy navbar logo - dla zwykłych ścieżek */}
          {!(
            location.pathname.startsWith("/news") ||
            location.pathname.startsWith("/updates")
          ) && (
            <div className="navBarLogoWrapper">
              <div
                className="navBarLogo"
                onClick={() => setSummaryVisible(!summaryVisible)}
                style={{ cursor: "pointer" }}
              >
                <p>
                  <img
                    src="/logo.png"
                    alt="logo"
                    style={{ width: "62px", height: "62px" }}
                  />
                </p>
                <div className="logo-text-container">
                  <p className="text-animate-brand">tehaque.dev</p>
                  <p className="text-animate-rotate">
                    {summaryVisible ? "▲" : "▼"}
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* Drugi navbar logo - dla news/updates */}
          {(location.pathname.startsWith("/news") ||
            location.pathname.startsWith("/updates")) && (
            <div
              className="navBarLogo extended-logo"
              onClick={() => setSummaryVisible(!summaryVisible)}
              style={{ cursor: "pointer" }}
            >
              <p>
                <img
                  src="/logo.png"
                  alt="logo"
                  style={{ width: "62px", height: "62px" }}
                />
              </p>
              <div className="logo-text-container">
                {location.pathname.startsWith("/updates") ? (
                  <>
                    <p className="text-animate-brand">tehaque.dev Updates</p>
                    <span className="beta-badge">BETA</span>
                  </>
                ) : (
                  <p className="text-animate-brand">tehaque.dev News</p>
                )}
                <p className="text-animate-rotate">
                  {summaryVisible ? "▲" : "▼"}
                </p>
              </div>
            </div>
          )}

          <li
            className={`nav-item ${location.pathname === "/" ? "is-active" : ""}`}
            onMouseEnter={handleNavItemHover}
          >
            <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
              <span className="nav-link-text">Home</span>
            </Link>
          </li>
          <li
            className={`nav-item updates-item ${location.pathname.startsWith("/updates") ? "is-active" : ""}`}
            onMouseEnter={handleNavItemHover}
          >
            <Link
              to="/updates"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <span className="nav-link-text">Updates</span>
              <span className="badge-new">NEW</span>
            </Link>
          </li>
          {navBarList.map((el, i) => (
            <NavItem key={i} id={el.id} index={i} title={el.title} />
          ))}
        </ul>

        {/* Nav controls: search / lang / perf / theme */}
        <div className="nav-controls">
          <button
            className="nav-ctrl"
            onClick={openDesktopSearchModal}
            title={t.search}
          >
            <svg
              width="13"
              height="13"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
          </button>
          <button
            className="nav-ctrl"
            onClick={onLangToggle}
            title={lang === "en" ? "Przełącz na polski" : "Switch to English"}
          >
            {lang === "en" ? "PL" : "EN"}
          </button>
          <button
            className={`nav-ctrl${perfMode ? " nav-ctrl--active" : ""}`}
            onClick={onPerfModeToggle}
            title={
              perfMode
                ? "Performance mode ON — kliknij aby wyłączyć"
                : "Włącz tryb wydajności (wyłącza animacje)"
            }
          >
            <svg
              width="13"
              height="13"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
            </svg>
          </button>
          <button
            className="nav-ctrl"
            onClick={onThemeToggle}
            title={theme === "dark" ? "Tryb jasny" : "Tryb ciemny"}
          >
            {theme === "dark" ? (
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <circle cx="12" cy="12" r="5" />
                <line x1="12" y1="1" x2="12" y2="3" />
                <line x1="12" y1="21" x2="12" y2="23" />
                <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
                <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
                <line x1="1" y1="12" x2="3" y2="12" />
                <line x1="21" y1="12" x2="23" y2="12" />
                <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
                <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
              </svg>
            ) : (
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
              </svg>
            )}
          </button>
        </div>

        <div
          className={`navBarItemWrappMain ${isHovered ? "is-open" : ""}`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => {
            setIsHovered(false);
          }}
        >
          <div
            className={`navBarItemWrapp ${isHovered ? "navItemActive" : ""}`}
          >
            <div
              className="navBarItemLeftImgWrap"
              style={{
                backgroundImage: `url(/${navBarList[activeSubMenu]?.img})`,
              }}
            >
              {/* <div className="gradientNav1"></div> */}
              {/* <span>{navBarList[activeSubMenu].title}</span> */}
            </div>
            <div className="navBarItemWrappInner">
              <div className="navBarItemEl">
                <div className="navSidebarHeader">
                  {navBarList[activeSubMenu]?.title?.toUpperCase()}
                </div>
                <div
                  className="navBarSubList"
                  ref={subNavListRef}
                  style={subIndicatorStyle}
                  onMouseLeave={syncSubIndicatorToActive}
                  onScroll={handleSubListScroll}
                >
                  {navBarList[activeSubMenu]?.args?.map((arg, i) => (
                    <NavItemDesc
                      key={i}
                      title={arg.name}
                      id={i}
                      href={arg.href}
                      isActive={activeDesc === i}
                    />
                  ))}
                </div>
                {navBarList[activeSubMenu] && (
                  <div className="navSidebarFooter">
                    <Link
                      to={
                        navBarList[activeSubMenu].id === 1 ? "/projects"
                        : navBarList[activeSubMenu].id === 2 ? "/news"
                        : navBarList[activeSubMenu].id === 3 ? "/profiles"
                        : "#"
                      }
                      className="navSidebarFooterLink"
                    >
                      View all →
                    </Link>
                  </div>
                )}
              </div>
              <div className="navBarItemBridge"></div>
              <div className="navBarItemElDesc">
                {(() => {
                  const category = navBarList?.[activeSubMenu];
                  const arg =
                    activeDesc !== 69 ? category?.args?.[activeDesc] : null;
                  const isProjects = category?.id === 1;
                  const isNewsCategory = category?.id === 2;
                  const isProfilesCategory = category?.id === 3;

                  const description = arg?.desc || category?.desc || "";
                  const relatedNewsRaw = isProjects
                    ? getLatestNews({
                        projectId: arg?.projectId,
                        onlyProjectNews: !arg?.projectId,
                      })
                    : isNewsCategory
                      ? getLatestNews()
                      : [];
                  const relatedNews = isProjects
                    ? relatedNewsRaw.slice(0, 2)
                    : relatedNewsRaw;
                  const project =
                    isProjects && arg?.projectId
                      ? Array.isArray(projects)
                        ? projects.find((p) => p?.id === arg.projectId)
                        : null
                      : null;
                  const authorsToShow =
                    isProfilesCategory && Array.isArray(authors)
                      ? authors.filter((a) => a?.nickname).slice(0, 2)
                      : [];
                  const descText = truncateText(
                    project?.description || description,
                    220,
                  );

                  const headerText = isProjects
                    ? arg?.projectId
                      ? t.latestFor(arg?.name)
                      : t.latestProjectNews
                    : isNewsCategory
                      ? t.latestNews
                      : "";

                  return (
                    <div className="navBarDescBlock">
                      <div className="navBarRightHeader">
                        <h3 className="navBarRightTitle">
                          {arg?.name || category?.title}
                        </h3>
                        {arg?.projectId ? (
                          <span className="navBarRightPill">Project</span>
                        ) : null}
                      </div>
                      {isProfilesCategory ? (
                        authorsToShow.length > 0 ? (
                          <div className="navBarProfilesGrid">
                            {authorsToShow.map((author) => (
                              <Link
                                key={author.id ?? author.nickname}
                                to={
                                  author?.id != null
                                    ? `/profiles/${author.id}`
                                    : "/profiles"
                                }
                                className="navBarProfileCard"
                              >
                                <div className="navBarProfile">
                                  <div className="navBarProfileAvatar">
                                    <img
                                      src={resolveMediaSrc(author.profilePic)}
                                      alt={author.nickname}
                                    />
                                  </div>
                                  <div className="navBarProfileBody">
                                    <p className="navBarProfileName">
                                      {author.nickname}
                                    </p>
                                    {author.bio ? (
                                      <p className="navBarDescText">
                                        {truncateText(author.bio, 140)}
                                      </p>
                                    ) : null}
                                    {Array.isArray(author.specialties) &&
                                    author.specialties.length > 0 ? (
                                      <div className="navBarProfileTags">
                                        {author.specialties
                                          .slice(0, 3)
                                          .map((s) => (
                                            <span
                                              key={s}
                                              className="navBarProfileTag"
                                            >
                                              {s}
                                            </span>
                                          ))}
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                              </Link>
                            ))}
                          </div>
                        ) : description ? (
                          <p className="navBarDescText">
                            {truncateText(description, 220)}
                          </p>
                        ) : null
                      ) : descText ? (
                        <p className="navBarDescText">{descText}</p>
                      ) : null}

                      {isProjects && project
                        ? (() => {
                            const media = [];
                            const projectImg = resolveMediaSrc(project.image);
                            if (projectImg) media.push(projectImg);
                            relatedNews.forEach((n) => {
                              const src = resolveMediaSrc(n?.img);
                              if (src) media.push(src);
                            });
                            const uniqueMedia = Array.from(
                              new Set(media),
                            ).slice(0, 2);
                            return uniqueMedia.length > 0 ? (
                              <div className="navBarMediaGrid">
                                {uniqueMedia.map((src) => (
                                  <div key={src} className="navBarMediaTile">
                                    <img src={src} alt="" />
                                  </div>
                                ))}
                              </div>
                            ) : null;
                          })()
                        : null}

                      {relatedNews.length > 0 ? (
                        <div className="navBarRelatedNews">
                          <div className="navBarRelatedNewsHeader">
                            <p>{headerText}</p>
                          </div>
                          <div className="navBarRelatedNewsList">
                            {relatedNews.map((item) => (
                              <Link
                                key={item.id}
                                to={getArticleHref(item)}
                                className="featured-news-item navBarRelatedNewsCard"
                              >
                                <div className="featured-news-image navBarRelatedNewsImage">
                                  {item.img ? (
                                    <img
                                      src={getImageSrc(item.img)}
                                      alt={item.title}
                                    />
                                  ) : null}
                                </div>
                                <div className="featured-news-content">
                                  <p className="featured-news-title">
                                    {item.title}
                                  </p>
                                  <div className="featured-news-meta">
                                    {Array.isArray(item.category) &&
                                    item.category.length > 0 ? (
                                      <span className="navBarNewsTag">
                                        {item.category[0]}
                                      </span>
                                    ) : null}
                                    <span className="featured-news-date">
                                      {item.date}
                                    </span>
                                  </div>
                                </div>
                              </Link>
                            ))}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  );
                })()}
              </div>
            </div>

            {/* <div className="lThYnU">
            <span>{navBarList[activeSubMenu].title.toLocaleUpperCase()}</span>
          </div>
          <div className="gradientNav1"></div> */}
          </div>
        </div>
      </nav>

      {/* Mobile Navigation */}
      {isMobile && (
        <>
          {/* Mobile Navbar Bar */}
          <nav className="mobile-navbar">
            <div className="mobile-navbar-content">
              <Link
                to="/"
                className="mobile-logo"
                onClick={() => mobileMenuVisible && setMobileMenuVisible(false)}
              >
                <span className="mobile-logo-tq">
                  T<span className="mobile-logo-q">Q</span>
                </span>
                <span className="mobile-logo-wordmark">tehaque.dev</span>
              </Link>
              <button
                className={`mobile-hamburger${mobileMenuVisible ? " active" : ""}`}
                onClick={() => setMobileMenuVisible(!mobileMenuVisible)}
                aria-label="Toggle menu"
              >
                <span />
                <span />
              </button>
            </div>
          </nav>

          {/* Mobile Menu Overlay */}
          <div className={`mobile-nav-overlay${mobileMenuVisible ? " visible" : ""}`}>
            <div className="mobile-nav-content">

              {/* Header */}
              <div className="mobile-nav-header">
                {currentNavLevel === "main" ? (
                  <span className="mobile-nav-header-title">MENU</span>
                ) : (
                  <button className="mobile-nav-back" onClick={navigateBack}>
                    ← {navBreadcrumbs[0]}
                  </button>
                )}
                <button className="mobile-nav-close" onClick={resetNavigation}>
                  <span /><span />
                </button>
              </div>

              {/* Scrollable Body */}
              <div className="mobile-nav-body">
                {/* Search */}
                <div className="mobile-nav-search-section">
                  <div className="mobile-nav-search-frame">
                    <svg className="mobile-nav-search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
                    </svg>
                    <input
                      type="text"
                      placeholder={t.search}
                      value={searchQuery}
                      onChange={(e) => handleSearch(e.target.value)}
                      className="mobile-nav-search-input"
                    />
                    {searchQuery && (
                      <button onClick={clearSearch} className="mobile-nav-search-clear">✕</button>
                    )}
                  </div>
                  {searchVisible && searchResults.length > 0 && (
                    <div className="mobile-nav-search-results">
                      {searchResults.slice(0, 6).map((result, index) => (
                        <div key={index} className="mobile-nav-search-result-frame">
                          {result.type === "category" ? (
                            <button
                              onClick={() => { result.onClick(); clearSearch(); }}
                              className={`mobile-nav-search-result-link ${result.type}`}
                            >
                              <div className="mobile-nav-search-result-text">
                                <span className="mobile-nav-search-result-title">{result.title}</span>
                                <span className="mobile-nav-search-result-category">{t.typeCategory}</span>
                              </div>
                            </button>
                          ) : (
                            <a
                              href={result.href}
                              onClick={() => { clearSearch(); resetNavigation(); }}
                              className={`mobile-nav-search-result-link ${result.type}`}
                              target={result.href.startsWith("http") ? "_blank" : "_self"}
                              rel={result.href.startsWith("http") ? "noopener noreferrer" : ""}
                            >
                              <div className="mobile-nav-search-result-text">
                                <span className="mobile-nav-search-result-title">{result.title}</span>
                                <div className="mobile-nav-search-result-category-container">
                                  <span className="mobile-nav-search-result-category">{result.category}</span>
                                  {result.type && <span className="mobile-nav-search-result-category">{result.type}</span>}
                                </div>
                                {result.content && <span className="mobile-nav-search-result-content">{result.content}</span>}
                                <div className="mobile-nav-search-result-meta">
                                  {result.date && <span className="mobile-nav-search-result-date">{result.date}</span>}
                                  {result.author && <span className="mobile-nav-search-result-author">by {result.author}</span>}
                                  {result.articleType && <span className="mobile-nav-search-result-status">{result.articleType}</span>}
                                </div>
                              </div>
                            </a>
                          )}
                        </div>
                      ))}
                      {searchResults.length > 6 && (
                        <div className="mobile-nav-search-result-more">{t.moreResults(searchResults.length - 6)}</div>
                      )}
                    </div>
                  )}
                </div>

                {/* Nav Links */}
                {currentNavLevel === "main" ? (
                  <div className="mobile-nav-links">
                    <Link
                      to="/"
                      onClick={resetNavigation}
                      className={`mobile-nav-link${location.pathname === "/" ? " is-active" : ""}`}
                    >
                      <span className="mobile-nav-link-text">Home</span>
                    </Link>
                    <Link
                      to="/updates"
                      onClick={resetNavigation}
                      className={`mobile-nav-link${location.pathname.startsWith("/updates") ? " is-active" : ""}`}
                    >
                      <span className="mobile-nav-link-text">Updates</span>
                      <span className="mobile-nav-badge">NEW</span>
                    </Link>
                    {navBarList.map((category) => {
                      const catPath = category.id === 1 ? "/projects" : category.id === 2 ? "/news" : category.id === 3 ? "/profiles" : null;
                      const isActive = catPath && location.pathname.startsWith(catPath);
                      return (
                        <button
                          key={category.id}
                          onClick={() => navigateToCategory(category)}
                          className={`mobile-nav-link mobile-nav-link--cat${isActive ? " is-active" : ""}`}
                        >
                          <span className="mobile-nav-link-text">{category.title}</span>
                          <span className="mobile-nav-arrow">→</span>
                        </button>
                      );
                    })}
                  </div>
                ) : (
                  (() => {
                    const currentCategory = navBarList.find((cat) => cat.id === currentNavLevel);
                    return currentCategory ? (
                      <div className="mobile-nav-links">
                        <p className="mobile-nav-cat-label">{currentCategory.title.toUpperCase()}</p>
                        {currentCategory.args.map((item) =>
                          item.href.startsWith("http") ? (
                            <a
                              key={item.id}
                              href={item.href}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={resetNavigation}
                              className="mobile-nav-link mobile-nav-link--sub"
                            >
                              <span className="mobile-nav-link-text">{item.name}</span>
                              <span className="mobile-nav-arrow">↗</span>
                            </a>
                          ) : (
                            <Link
                              key={item.id}
                              to={item.href}
                              onClick={resetNavigation}
                              className={`mobile-nav-link mobile-nav-link--sub${location.pathname === item.href ? " is-active" : ""}`}
                            >
                              <span className="mobile-nav-link-text">{item.name}</span>
                            </Link>
                          )
                        )}
                      </div>
                    ) : null;
                  })()
                )}
              </div>

              {/* Footer Controls */}
              <div className="mobile-nav-footer">
                <button
                  className="mobile-nav-ctrl"
                  onClick={onLangToggle}
                  title={lang === "en" ? "Przełącz na polski" : "Switch to English"}
                >
                  {lang === "en" ? "PL" : "EN"}
                </button>
                <button
                  className={`mobile-nav-ctrl${perfMode ? " mobile-nav-ctrl--on" : ""}`}
                  onClick={onPerfModeToggle}
                  title={perfMode ? "Performance mode ON" : "Performance mode OFF"}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
                  </svg>
                </button>
                <button
                  className="mobile-nav-ctrl"
                  onClick={onThemeToggle}
                  title={theme === "dark" ? "Tryb jasny" : "Tryb ciemny"}
                >
                  {theme === "dark" ? (
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <circle cx="12" cy="12" r="5" />
                      <line x1="12" y1="1" x2="12" y2="3" /><line x1="12" y1="21" x2="12" y2="23" />
                      <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" /><line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
                      <line x1="1" y1="12" x2="3" y2="12" /><line x1="21" y1="12" x2="23" y2="12" />
                      <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" /><line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
                    </svg>
                  ) : (
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
                    </svg>
                  )}
                </button>
              </div>

            </div>
          </div>
        </>
      )}

      {/* Desktop Search Modal */}
      {desktopSearchModalOpen && (
        <div
          className="desktop-search-modal-overlay"
          onClick={closeDesktopSearchModal}
        >
          <div
            className="desktop-search-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Search Filters */}
            {/* <div className="desktop-search-modal-filters">
              <button 
                className={`desktop-search-filter ${searchFilter === 'all' ? 'active' : ''}`}
                onClick={() => setSearchFilter('all')}
              >
                Wszystko
              </button>
              <button 
                className={`desktop-search-filter ${searchFilter === 'article' ? 'active' : ''}`}
                onClick={() => setSearchFilter('article')}
              >
                Artykuły
              </button>
              <button 
                className={`desktop-search-filter ${searchFilter === 'project' ? 'active' : ''}`}
                onClick={() => setSearchFilter('project')}
              >
                Projekty
              </button>
              <button 
                className={`desktop-search-filter ${searchFilter === 'update' ? 'active' : ''}`}
                onClick={() => setSearchFilter('update')}
              >
                Aktualizacje
              </button>
              <button 
                className={`desktop-search-filter ${searchFilter === 'author' ? 'active' : ''}`}
                onClick={() => setSearchFilter('author')}
              >
                Autorzy
              </button>
              <button 
                className={`desktop-search-filter ${searchFilter === 'announcement' ? 'active' : ''}`}
                onClick={() => setSearchFilter('announcement')}
              >
                Ogłoszenia
              </button>
            </div> */}

            <div className="desktop-search-modal-header">
              <div className="desktop-search-modal-input-frame">
                <input
                  type="text"
                  placeholder={t.search}
                  value={searchQuery}
                  onChange={(e) => handleSearch(e.target.value)}
                  className="desktop-search-modal-input"
                  autoFocus
                />
                {searchQuery && (
                  <button
                    onClick={clearSearchInput}
                    className="desktop-search-modal-clear"
                  >
                    ✕
                  </button>
                )}
              </div>
              <button
                className="desktop-search-modal-close"
                onClick={closeDesktopSearchModal}
              >
                ✕
              </button>
            </div>

            {/* Desktop Modal Search Results */}
            {searchVisible && searchResults.length > 0 && (
              <div className="desktop-search-modal-results">
                {searchResults.slice(0, 10).map((result, index) => (
                  <div
                    key={index}
                    className="desktop-search-modal-result-frame"
                  >
                    <a
                      href={result.href}
                      onClick={() => {
                        closeDesktopSearchModal();
                      }}
                      className={`desktop-search-modal-result-link ${result.type}`}
                      target={
                        result.href?.startsWith("http") ? "_blank" : "_self"
                      }
                      rel={
                        result.href?.startsWith("http")
                          ? "noopener noreferrer"
                          : ""
                      }
                    >
                      {(result.type === "article" ||
                        result.type === "news") && (
                        <div className="desktop-search-modal-result-image">
                          <div className="desktop-search-modal-result-image-placeholder"></div>
                        </div>
                      )}
                      <div className="desktop-search-modal-result-text">
                        <span className="desktop-search-modal-result-title">
                          {result.title}
                        </span>
                        <div className="desktop-search-modal-result-category-container">
                          <span className="desktop-search-modal-result-category">
                            {result.category}
                          </span>
                          <span className="desktop-search-modal-result-category">
                            {result.type}
                          </span>
                        </div>
                        {result.content && (
                          <span className="desktop-search-modal-result-content">
                            {result.content}
                          </span>
                        )}
                        {result.author && (
                          <span className="desktop-search-modal-result-author">
                            {t.by}: {result.author}
                          </span>
                        )}
                        {result.date && (
                          <span className="desktop-search-modal-result-date">
                            {result.date}
                          </span>
                        )}
                        {result.status && (
                          <span className="desktop-search-modal-result-status">
                            {result.status}
                          </span>
                        )}
                      </div>
                    </a>
                  </div>
                ))}
                {searchResults.length > 10 && (
                  <div className="desktop-search-modal-result-more">
                    {t.moreResults(searchResults.length - 10)}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default NavBar;
